import PropTypes from 'prop-types';
import Card from "../../Card/Card";
import CardSection from "../../Card/CardSection";
import EligibilityItem from "./EligibilityItem";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DISPLAY_NAME = 'program-detail-eligibility-type';
const eligibilityItem = item => {
  return item.map(_ref => {
    let {
      visibility,
      title,
      options
    } = _ref;
    return /*#__PURE__*/_jsx(EligibilityItem, {
      visibility: visibility,
      title: title,
      options: options
    }, title);
  });
};
function Eligibility(_ref2) {
  let {
    eligibilityText,
    populationSpecializations,
    populationRestrictions,
    paymentOptions,
    accessibilityOptions,
    deliveryOptions,
    transportationOptions,
    cityRequirements,
    countyRequirements,
    stateRequirements,
    ageSpecializations,
    genderRequirements,
    ageRequirements,
    postalCodeRequirements,
    languages,
    hasRequirements,
    hasAccessibility,
    hasOtherEligibility,
    hasEligibility
  } = _ref2;
  const requirements = [{
    visibility: !!stateRequirements,
    title: "States",
    options: stateRequirements
  }, {
    visibility: !!postalCodeRequirements,
    title: "ZIP Codes",
    options: postalCodeRequirements
  }, {
    visibility: !!countyRequirements,
    title: "Counties",
    options: countyRequirements
  }, {
    visibility: !!cityRequirements,
    title: "Cities",
    options: cityRequirements
  }, {
    visibility: !!ageRequirements,
    title: "Ages",
    options: ageRequirements
  }, {
    visibility: !!genderRequirements,
    title: "Genders",
    options: genderRequirements
  }, {
    visibility: !!populationRestrictions,
    title: "Populations",
    options: populationRestrictions
  }];
  const accessibility = [{
    visibility: !!deliveryOptions,
    title: "Program Delivery",
    options: deliveryOptions
  }, {
    visibility: !!languages,
    title: "Supported Languages",
    options: languages
  }, {
    visibility: !!populationSpecializations,
    title: "Populations Specialized In",
    options: populationSpecializations
  }, {
    visibility: !!ageSpecializations,
    title: "Ages Specialized In",
    options: ageSpecializations
  }, {
    visibility: !!accessibilityOptions,
    title: "Accessibility Services",
    options: accessibilityOptions
  }, {
    visibility: !!transportationOptions,
    title: "Transportation Options",
    options: transportationOptions
  }, {
    visibility: !!paymentOptions,
    title: "Payment Options",
    options: paymentOptions
  }];
  const requirementsList = eligibilityItem(requirements);
  const accessbilityList = eligibilityItem(accessibility);
  return hasEligibility && /*#__PURE__*/_jsxs(Card, {
    title: "Program Criteria",
    className: "border border-solid rounded border-med-pale-blue bg-white mb-6",
    children: [hasRequirements && /*#__PURE__*/_jsx(CardSection, {
      title: "Eligibility Requirements:",
      className: "border-b border-solid border-med-pale-blue p-3",
      children: /*#__PURE__*/_jsx("div", {
        className: "mx-4",
        children: /*#__PURE__*/_jsx("ul", {
          className: "".concat(DISPLAY_NAME, "-list list-disc pl-2"),
          children: requirementsList
        })
      })
    }), hasOtherEligibility && /*#__PURE__*/_jsx(CardSection, {
      title: "Other Eligibility Requirements:",
      className: "border-b border-solid border-med-pale-blue p-3",
      children: /*#__PURE__*/_jsx("div", {
        className: "mx-4",
        children: /*#__PURE__*/_jsx("p", {
          dangerouslySetInnerHTML: {
            __html: eligibilityText
          }
        })
      })
    }), hasAccessibility && /*#__PURE__*/_jsx(CardSection, {
      title: "Accessibility and Specializations:",
      className: "border-b border-solid border-med-pale-blue p-3",
      children: /*#__PURE__*/_jsx("div", {
        className: "mx-4",
        children: /*#__PURE__*/_jsx("ul", {
          className: "".concat(DISPLAY_NAME, "-list list-disc pl-2"),
          children: accessbilityList
        })
      })
    })]
  });
}
Eligibility.propTypes = {
  eligibilityText: PropTypes.string,
  populationSpecializations: PropTypes.string.isRequired,
  populationRestrictions: PropTypes.string.isRequired,
  paymentOptions: PropTypes.string.isRequired,
  accessibilityOptions: PropTypes.string.isRequired,
  deliveryOptions: PropTypes.string.isRequired,
  transportationOptions: PropTypes.string.isRequired,
  cityRequirements: PropTypes.string.isRequired,
  countyRequirements: PropTypes.string.isRequired,
  stateRequirements: PropTypes.string.isRequired,
  ageSpecializations: PropTypes.string.isRequired,
  genderRequirements: PropTypes.string.isRequired,
  ageRequirements: PropTypes.string.isRequired,
  postalCodeRequirements: PropTypes.string.isRequired,
  languages: PropTypes.string.isRequired,
  hasRequirements: PropTypes.bool.isRequired,
  hasAccessibility: PropTypes.bool.isRequired,
  hasOtherEligibility: PropTypes.bool.isRequired,
  hasEligibility: PropTypes.bool.isRequired
};
Eligibility.defaultProps = {
  eligibilityText: ''
};
export default Eligibility;
//# sourceMappingURL=Eligibility.js.map